import type { Stage } from '../../types';

export const pregnancy1: Stage = {
  id: 'pregnancy-1',
  key: '1',
  title: '妊娠初期',
  subtitle: '小さな命を受け入れる',
  weeks: '〜13週',
  description:
    'つわりや体調の変化が大きい時期です。無理をせず、今日から1つずつ必要な手続きと情報を整えましょう。',
  mindCards: [
    {
      id: 'm1',
      title: '体調を味方にする',
      body: '眠かったら眠り、食べたいものを食べる。毎日同じでなくても大丈夫です。',
      type: 'body',
    },
    {
      id: 'm2',
      title: '小さな一歩で進める',
      body: '母子手帳や産院の手続きは、今日から1つずつ進めれば十分です。',
      type: 'mind',
    },
    {
      id: 'm3',
      title: 'パートナーと一緒に',
      body: '妊娠の気づきを共有し、これからの役割を夫婦で話し合いましょう。',
      type: 'mind',
    },
    {
      id: 'm4',
      title: '不安を隠さない',
      body: '心身の変化に戸惑うのは自然です。相談できる窓口を決めておきましょう。',
      type: 'mind',
    },
    {
      id: 'm5',
      title: '医療費の記録を始める',
      body: '領収書や通院記録をひとまとめに。後の手続きがスムーズになります。',
      type: 'life',
    },
    {
      id: 'm6',
      title: '葉酸は継続的に',
      body: '食事とサプリで補い、医師や薬局と相談しながら続けましょう。',
      type: 'body',
    },
    {
      id: 'm7',
      title: '母子モで情報を受け取る',
      body: 'にいがた子育て応援アプリ「母子モ」に登録し、お知らせや相談窓口を確認しましょう。（新潟市の例）',
      type: 'life',
    },
    {
      id: 'm8',
      title: '受動喫煙も防ぐ',
      body: '加熱式たばこも含め、妊婦や乳幼児のそばでの喫煙は避けてもらいましょう。',
      type: 'partner',
    },
  ],
  checklist: [
    { id: 'c1', text: '母子手帳を受け取り、必要事項を記入する', category: 'admin', note: '居住地の市町村で申請できます。新潟市では「母子モ」アプリの登録も案内されます。' },
    { id: 'c2', text: '産婦人科を決め、初回健診を予約する', category: 'hospital', note: '通院しやすさと夜間対応を確認' },
    { id: 'c3', text: '葉酸サプリや食事のバランスを確認する', category: 'body', note: '妊娠前〜妊娠初期は1日400μgの摂取が目安（個人差あり）' },
    { id: 'c4', text: '禁煙・禁酒・カフェインの目安を確認する', category: 'body', note: 'カフェインは1日200mg以内を目安に' },
    { id: 'c5', text: '職場への報告時期を検討する', category: 'admin', note: '安定期に入ってから報告する人が多い' },
    { id: 'c6', text: '産休・育休の手続きを調べる', category: 'admin', note: '会社の規定と雇用保険の要件を確認' },
    { id: 'c7', text: '出産費用と出産育児一時金の概要を確認する', category: 'admin', note: '健康保険組合や自治体で確認' },
    { id: 'c8', text: '妊娠の記録をつけ始める', category: 'life', note: '体重、血圧、つわりの具合など' },
    { id: 'c9', text: 'パートナーと家事分担を話す', category: 'partner', note: '具体的なタスクを割り振りましょう' },
    { id: 'c10', text: '初めての健診で聞きたいことをメモする', category: 'hospital', note: '質問リストを用意しておく' },
    { id: 'c11', text: 'つわりの対策を生活に取り入れる', category: 'body', note: '冷たいもの、小分け食事、休息など' },
    { id: 'c12', text: '心身の変化に驚かず、自分を許す', category: 'mind', note: '情緒不安定になりやすい時期です' },
    { id: 'c13', text: '医療費の領収書を保管する', category: 'admin', note: '高額療養費や控除で後から使う場合あり' },
    { id: 'c14', text: 'マタニティマークを準備する', category: 'shopping', note: '電車や職場で使うと便利です' },
    { id: 'c15', text: '近所の助産院・相談窓口を調べる', category: 'hospital', note: '緊急時の連絡先として覚えておく' },
    { id: 'c16', text: 'パートナーと出産のイメージを共有する', category: 'partner', note: '立ち会いや里帰りの方針など' },
    { id: 'c17', text: '睡眠リズムを整える', category: 'life', note: '疲れやすい時期は無理せず寝る' },
    { id: 'c18', text: '通勤ルートの負担を見直す', category: 'life', note: '混雑時間や座れる時間帯を調整' },
    { id: 'c19', text: '栄養バランスの食事を心がける', category: 'body', note: '一汁三菜を基本に、野菜・たんぱく質・鉄分を意識' },
    { id: 'c20', text: '職場の産休取得に必要な書類を確認する', category: 'admin', note: '医師の診断書が必要な場合も' },
    { id: 'c21', text: '母子モ（にいがた子育て応援アプリ）に登録する', category: 'admin', note: '新潟市の例。他の自治体では同名アプリや通知サービスが異なります。' },
    { id: 'c22', text: '妊産婦医療費助成の申請をする', category: 'admin', note: '母子健康手帳交付後、できるだけ早く。受給資格認定日から助成対象期間が始まります。' },
    { id: 'c23', text: '妊婦支援給付金（1回目）の申請を確認する', category: 'admin', note: '胎児心拍を確認した日から2年以内。新潟市の例。' },
    { id: 'c24', text: '国民健康保険・国民年金の産前産後免除を確認する', category: 'admin', note: '出産予定日の6か月前から届出可能。年金受給額は減りません。' },
    { id: 'c25', text: '食事は一汁三菜・塩分6.5g未満を目安にする', category: 'body', note: '妊娠中期からは+250kcal、末期・授乳期は+450kcalが目安（一般論）' },
    { id: 'c26', text: '市販薬・サプリメントは自己判断せず医師に相談する', category: 'body', note: '薬の成分が胎児に影響を与える可能性があります' },
    { id: 'c27', text: '口腔ケアを毎日続ける', category: 'body', note: '歯周病は早産リスクを高めるため、妊婦歯科健診も活用' },
    { id: 'c28', text: '水銀を多く含む魚の過剰摂取に注意する', category: 'body', note: 'キダイ・マカジキ・ミナミマグロ・金目鯛などは週1〜2回など量に注意' },
  ],
  shopping: [
    {
      id: 's1',
      name: 'マタニティマーク',
      priority: 'must',
      timing: 'いつからでも',
      priceYenMin: 0,
      priceYenMax: 1000,
      note: '市町村や病院で無料の場合もあります',
    },
    {
      id: 's2',
      name: '葉酸サプリ',
      priority: 'must',
      timing: '妊娠早期から',
      priceYenMin: 1500,
      priceYenMax: 4500,
      note: '個人差があり、医師と相談してください',
    },
    {
      id: 's3',
      name: '妊娠線ケアオイル・クリーム',
      priority: 'nice',
      timing: '中期から',
      priceYenMin: 2000,
      priceYenMax: 6000,
      note: '保湿を心がける',
    },
    {
      id: 's4',
      name: '綿100%のゆったりショーツ',
      priority: 'should',
      timing: 'いつからでも',
      priceYenMin: 1500,
      priceYenMax: 4000,
      note: '締め付けない素材を選ぶ',
    },
    {
      id: 's5',
      name: '温かいルームウェア',
      priority: 'should',
      timing: 'いつからでも',
      priceYenMin: 3000,
      priceYenMax: 8000,
      note: 'つわり中も快適に過ごせるもの',
    },
    {
      id: 's6',
      name: '体重・体組成計',
      priority: 'nice',
      timing: 'いつからでも',
      priceYenMin: 2000,
      priceYenMax: 8000,
      note: '健診で体重管理が必要になります',
    },
    {
      id: 's7',
      name: 'マタニティ日記帳',
      priority: 'nice',
      timing: 'いつからでも',
      priceYenMin: 1000,
      priceYenMax: 3000,
      note: 'アプリでも代用可能',
    },
    {
      id: 's8',
      name: '低刺激のスキンケアセット',
      priority: 'should',
      timing: 'いつからでも',
      priceYenMin: 2000,
      priceYenMax: 6000,
      note: '肌が敏感になりやすい時期',
    },
    {
      id: 's9',
      name: 'マタニティピロー',
      priority: 'nice',
      timing: '中期から',
      priceYenMin: 3000,
      priceYenMax: 10000,
      note: 'お腹が大きくなってから活躍',
    },
    {
      id: 's10',
      name: 'ノンカフェイン飲料',
      priority: 'should',
      timing: 'いつからでも',
      priceYenMin: 1000,
      priceYenMax: 3000,
      note: '麦茶、ルイボスティーなど',
    },
    {
      id: 's11',
      name: '保冷剤付きエコバッグ',
      priority: 'nice',
      timing: 'いつからでも',
      priceYenMin: 1000,
      priceYenMax: 3000,
      note: '健診時の水分補給に便利',
    },
    {
      id: 's12',
      name: 'マタニティブラ・授乳ブラ',
      priority: 'should',
      timing: '中期〜後期',
      priceYenMin: 2000,
      priceYenMax: 6000,
      note: '楽な着け心地を優先。産後も使えるデザインを',
    },
    {
      id: 's13',
      name: 'お口ケアセット（小さめ歯ブラシ・うがい薬）',
      priority: 'should',
      timing: 'いつからでも',
      priceYenMin: 500,
      priceYenMax: 2000,
      note: 'つわりで磨きにくい時は小さめヘッドやうがい薬を活用',
    },
  ],
  warnings: [
    { id: 'w1', label: '激しい腹痛や出血', level: 'urgent' },
    { id: 'w2', label: '意識がもうろうとする', level: 'urgent' },
    { id: 'w3', label: '片側の激痛', level: 'urgent' },
    { id: 'w4', label: 'つわりで何も食べられない', level: 'watch' },
    { id: 'w5', label: '38℃以上の発熱', level: 'watch' },
    { id: 'w6', label: '尿が出にくい・痛い', level: 'watch' },
    { id: 'w7', label: '強い頭痛や吐き気', level: 'watch' },
    { id: 'w8', label: '下腹部の張り', level: 'watch' },
    { id: 'w9', label: '出血が少量でも続く', level: 'watch' },
  ],
  partner: [
    { id: 'p1', text: '一緒に産院を選び、見学に行く' , detail: '通いやすさ・夜間対応・立ち会い可否を夫婦でリスト化し、候補を2〜3院に絞って見学予約を。新潟市内なら通勤・緊急時の移動時間も一緒に見る。'},
    { id: 'p2', text: '家事を引き受ける宣言をする' , detail: '「洗い物」「ゴミ」「夕飯」など具体タスクを書き、今週からパパが1つ担当する。妊娠中から分担を練習すると産後が楽。'},
    { id: 'p3', text: '妊娠の記録を一緒に書く時間をつくる' , detail: '週1回、母子手帳やアプリの記録を一緒に見る時間を10分作る。不安や予定の共有にもなる。'},
    { id: 'p4', text: 'つわり中の食事をサポートする' , detail: '食べられるものを聞き、常備食や冷凍を増やす。匂いがつらい日は別室で食事でもOKと伝える。'},
    { id: 'p5', text: '夜のお使いや買い物を引き受ける' , detail: '夜の買い物・薬局・ゴミ捨てを引き取る。ママが横になれる時間を先に確保する。'},
    { id: 'p6', text: '産休取得の計画を会社と確認する' , detail: '会社の産休・育休・パパ育休の申請期限を確認し、カレンダーに入れる。ママの職場報告のタイミングも相談。'},
    { id: 'p7', text: 'ママの無理を促さず、休息を勧める' , detail: '「大丈夫？」より「今日は何を引き取る？」と具体的に聞く。休息を勧める声かけを習慣に。'},
    { id: 'p8', text: '受動喫煙防止を家庭内で徹底する' , detail: '加熱式も含め、妊婦・乳幼児のそばでは吸わないルールを家族で決める。換気扇下でも副流煙は防げない。'},
  ],
  tips: [
    {
      id: 't1',
      title: 'つわりは乗り物より「食べること」',
      body: '空腹が続くと逆につらくなることが多いです。小分けに食べられるものを常備すると、気分が楽になります。',
    },
    {
      id: 't2',
      title: '産院選びは「通いやすさ」が大事',
      body: '設備だけでなく、急な時の連絡、夜間の体制、スタッフの雰囲気も合わせて見ましょう。',
    },
    {
      id: 't3',
      title: '医療費は「記録する癖」をつける',
      body: '母子手帳のポケットに領収書をまとめておく。出産費用の見通しや控除の準備に役立ちます。',
    },
    {
      id: 't4',
      title: '職場報告は心の余裕を持って',
      body: '安定期に入る前でも、体調が安定したタイミングで上司に伝えると、後の調整がしやすいです。',
    },
    {
      id: 't5',
      title: 'つわり対策：冷たく・小さく・こまめに水分',
      body: '水、お茶、無糖の炭酸水などでこまめに水分補給。料理は冷やすと食べやすいこともあります。',
    },
    {
      id: 't6',
      title: '食事の基本は一汁三菜',
      body: '主食・主菜・副菜・汁物を組み合わせ、塩分は1日6.5g未満を目安に。葉酸・鉄・カルシウムを意識しましょう。',
    },
    {
      id: 't7',
      title: '禁煙・禁酒は受動喫煙も含めて',
      body: '加熱式たばこも避け、車内や家族の前では絶対に吸わないルールを作りましょう。',
    },
    {
      id: 't8',
      title: '市販薬は自己判断しない',
      body: '妊娠中・授乳中の薬は、必ず産婦人科医・主治医・薬剤師に相談して指示を仰ぎましょう。',
    },
  ],
  adminGuide: [
    {
      id: 'a1',
      title: '母子手帳の交付',
      body: '居住地の市町村の窓口で申請。妊娠が確認できたら早めに受け取り、妊婦健診の受診券などもセットで確認しましょう。',
      when: '妊娠判明後すぐ',
    },
    {
      id: 'a2',
      title: '出産育児一時金の概要',
      body: '健康保険に加入していれば出産1件ごとに給付金があります。2023年10月からは出産費用への直接支払い（産科医療補償制度）が始まっています。',
      when: '出産前後に手続き',
    },
    {
      id: 'a3',
      title: '妊婦健診の補助券',
      body: '母子手帳に貼付する健診受診券で、一定回数の妊婦健診が受診しやすくなります。自治体により回数や金額が異なります。',
      when: '母子手帳交付時',
    },
    {
      id: 'a4',
      title: '産休・育休の取得手続き',
      body: '産休は出産予定日6週前から取得可能。育休は出産後8週間経過後に取得できます。雇用保険の給付要件も確認してください。',
      when: '妊娠中期〜後期に会社へ申請',
    },
    {
      id: 'a5',
      title: '医療費控除・高額療養費',
      body: '年間の医療費が10万円を超える場合、確定申告で控除対象になることがあります。領収書は必ず保管しましょう。',
      when: '出産翌年の確定申告',
    },
    {
      id: 'a6',
      title: '妊産婦医療費助成の申請',
      body: '新潟市に住所がある妊産婦を対象に、医療費の一部負担金を除いた額を助成。受給資格認定日から助成期間が始まるため、早めに申請してください。',
      when: '母子健康手帳交付後すぐ',
    },
    {
      id: 'a7',
      title: '妊婦支援給付金（1回目）',
      body: '新潟市で妊娠届を提出した妊婦が対象。胎児心拍を確認した日から2年以内に電子申請で手続きします。',
      when: '妊娠初期〜',
    },
    {
      id: 'a8',
      title: '国民健康保険・国民年金の産前産後免除',
      body: '産前産後期間の保険料が免除・軽減されます。国民年金の受給額は減りません。出産予定日の6か月前から届出可能です。',
      when: '妊娠中期〜出産後',
    },
  ],
  exercises: [
    {
      id: 'ex1',
      title: 'アドリエンの妊婦ヨガ',
      durationMin: 22,
      url: 'https://www.youtube.com/watch?v=-3bvlFKeLRE',
      channel: 'アドリエンのヨガ',
      note: '全妊娠期対応。呼吸を中心にしたやさしい動きで、初心者にもおすすめです。',
      level: 'gentle',
    },
    {
      id: 'ex2',
      title: '妊婦さん向け初心者ワークアウト（10分）',
      durationMin: 10,
      url: 'https://www.youtube.com/watch?v=2_uOYGstJj4',
      channel: '妊娠・産後エクササイズチャンネル',
      note: '短時間でできる初心者向け。つわりがつらい日でも無理なく続けられます。',
      level: 'gentle',
    },
    {
      id: 'ex3',
      title: '妊娠全期向けワークアウト（15分）',
      durationMin: 15,
      url: 'https://www.youtube.com/watch?v=zmUJWKM98hM',
      channel: '妊娠・産後エクササイズチャンネル',
      note: '全妊娠期対応の全身運動。体調と相談しながら行いましょう。',
      level: 'gentle',
    },
  ],
};
